// Plausible Analytics loader — only mounts when REACT_APP_PLAUSIBLE_DOMAIN is set.
// Set the domain in /app/frontend/.env to enable.
import { useEffect } from "react";

export default function Plausible() {
  useEffect(() => {
    const domain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
    const src = process.env.REACT_APP_PLAUSIBLE_SCRIPT_URL || "https://plausible.io/js/script.js";
    if (!domain) return undefined;

    // Avoid double-injection across hot reloads.
    if (document.querySelector('script[data-noor-plausible="true"]')) return undefined;

    const s = document.createElement("script");
    s.defer = true;
    s.setAttribute("data-domain", domain);
    s.setAttribute("data-noor-plausible", "true");
    s.src = src;
    document.head.appendChild(s);

    // Expose plausible() for custom events (e.g. "Edition Application Submitted").
    if (!window.plausible) {
      window.plausible = function () {
        // eslint-disable-next-line prefer-rest-params
        (window.plausible.q = window.plausible.q || []).push(arguments);
      };
    }
    return undefined;
  }, []);

  return null;
}
